import { calendar } from '@/api/calendars.js'
import store from '@/store'

let res = null

export const calendars = {
    namespaced: true,
    state: {
        originals: null,
        schedules: null,
        recipients: null,
        staffs: null,
    },
    mutations: {
        // SCHEDULES_LIST(state, payload) {
        //     if (payload.type === 'work') {
        //         state.schedules = state.originals = payload.calendarListView
        //             ? payload.calendarListView.filter( 
        //                 item => item.calClassCode === '16' || item.calClassCode === '11')
        //             : null
        //     } else if (payload.type === 'employee') {
        //         state.schedules = state.originals = payload.calendarListView
        //             ? payload.calendarListView.filter( 
        //                 item => item.calClassCode === '13' || item.calClassCode === '17')
        //             : null
        //     } else if (payload.type === 'mine') {
        //         state.schedules = state.originals = payload.calendarListView
        //             ? payload.calendarListView.filter(
        //                 item => item.calClassCode === '11' || item.calClassCode === '13')
        //             : null
        //     }

        //     state.recipients = (payload.type==='mine')?null:payload.recipientList
        //     state.staffs = (payload.type==='mine')?null:payload.staffList
        // },
        SCHEDULES_LIST(state, payload) {
            state.schedules = payload.calendarListView
            state.staffs = payload.staffList
            state.recipients = payload.recipientList
        },
        ADD_A_SCHEDULE(state, payload) {
            if (!state.schedules) state.schedules = []
            state.schedules.push(payload.calendar)
        },
        ADD_A_COMPANY_SCHEDULE(state, payload) {
            if (!state.schedules) state.schedules = []
            state.schedules.push(payload.calendar)
        },
        UPDATE_A_SCHEDULE(state, payload) {
            //
        }
    },
    actions: {
        // @Description 내 개인 스케줄 호출
        // async SCHEDULES_LIST({commit}, payload) {
        //     try {
        //         store.dispatch('OPEN_LOADING')
        //         res = await calendar.get.calendars(payload)
        //         console.log("SCHEDULES_LIST info", res)
        //         if (res.data.status === 200) {
        //             store.dispatch('OPEN_SYSTEM_BAR', {
        //                 message: res.data.message,
        //                 color: 'success'
        //             })
        //             commit('SCHEDULES_LIST', res.data.data)
        //         } else {
        //             store.dispatch('OPEN_SYSTEM_BAR', {
        //                 message: res.data.message,
        //                 color: 'error'
        //             })
        //         }
        //         store.dispatch('CLOSE_LOADING')
        //         return res.data
        //     } catch (error) {
        //         console.error("SCHEDULES_LIST error", error)
        //         store.dispatch('CLOSE_LOADING')
        //     }
        // },
        // @Description 회사 내 나의 일정 가져오기
        async SCHEDULES_LIST({commit}, payload) {
            try {
                store.dispatch('OPEN_LOADING')
                res = await calendar.get.management(payload)
                console.log("SCHEDULES_LIST info", res)
                if (res.data.status === 200) {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success'
                    })
                    commit('SCHEDULES_LIST', res.data.data)
                } else {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.dispatch('CLOSE_LOADING')
                return res.data
            } catch (error) {
                console.error("SCHEDULES_LIST error", error)
                store.dispatch('CLOSE_LOADING')
            }
        },
        // @Description 직원 급여 스케줄 가져오기
        async STAFF_LIST({commit}, payload) {
            try {
                store.dispatch('OPEN_LOADING')
                res = await calendar.get.staff(payload)
                console.log("STAFF_LIST info", res)
                if (res.data.status === 200) {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success'
                    })
                    commit('SCHEDULES_LIST', res.data.data)
                } else {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.dispatch('CLOSE_LOADING')
                return res.data
            } catch (error) {
                console.error("STAFF_LIST error", error)
                store.dispatch('CLOSE_LOADING')
            }
        },
        // @Description 개인일정 확인하기
        async ADD_A_SCHEDULE({commit}, payload) {
            try {
                store.dispatch('OPEN_LOADING')
                res = await calendar.post.personal(payload)
                console.log("ADD_A_SCHEDULE info", res)
                if (res.data.status === 201) {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success'
                    })
                    commit('ADD_A_SCHEDULE', res.data.data)
                } else {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.dispatch('CLOSE_LOADING')
                return res.data
            } catch (error) {
                console.error("ADD_A_SCHEDULE error", error)
                store.dispatch('CLOSE_LOADING')
            }
        },
        // @Description 개인일정 업데이트
        async UPDATE_A_SCHEDULE({commit}, payload) {
            try {
                store.dispatch('OPEN_LOADING')
                res = await calendar.post.personalUpdate(payload)
                console.log("UPDATE_A_SCHEDULE info", res)
                if (res.data.status === 201) {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success'
                    })
                    commit('UPDATE_A_SCHEDULE', res.data.data)
                } else {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.dispatch('CLOSE_LOADING')
                return res.data
            } catch (error) {
                console.error("UPDATE_A_SCHEDULE error", error)
                store.dispatch('CLOSE_LOADING')
            }
        },
        // @Description 회사일정 확인하기
        async ADD_A_COMPANY_SCHEDULE({commit}, payload) {
            try {
                store.dispatch('OPEN_LOADING')
                res = await calendar.post.customer(payload)
                console.log("ADD_A_COMPANY_SCHEDULE info", res)
                if (res.data.status === 201) {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success'
                    })
                    commit('ADD_A_COMPANY_SCHEDULE', res.data.data)
                } else {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.dispatch('CLOSE_LOADING')
                return res.data
            } catch (error) {
                console.error("ADD_A_COMPANY_SCHEDULE error", error)
                store.dispatch('CLOSE_LOADING')
            }
        },
        // @Description 회사일정 업데이트
        async UPDATE_A_COMPANY_SCHEDULE({commit}, payload) {
            try {
                store.dispatch('OPEN_LOADING')
                res = await calendar.post.customerUpdate(payload)
                console.log("UPDATE_A_COMPANY_SCHEDULE info", res)
                if (res.data.status === 201) {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success'
                    })
                    commit('UPDATE_A_COMPANY_SCHEDULE', res.data.data)
                } else {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.dispatch('CLOSE_LOADING')
                return res.data
            } catch (error) {
                console.error("UPDATE_A_COMPANY_SCHEDULE error", error)
                store.dispatch('CLOSE_LOADING')
            }
        },
        // @Description 개인일정 삭제
        async DELETE_A_SCHEDULE({commit}, payload) {
            try {
                store.dispatch('OPEN_LOADING')
                res = await calendar.delete.personal(payload)
                console.log("DELETE_A_SCHEDULE info", res)
                if (res.data.status === 201) {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success'
                    })
                } else {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.dispatch('CLOSE_LOADING')
                return res.data
            } catch(error) {
                console.error("DELETE_A_SCHEDULE error", error)
                store.dispatch('CLOSE_LOADING')
            }
        },
        // @Description 회사일정 삭제
        async DELETE_A_COMPANY_SCHEDULE({commit}, payload) {
            try {
                store.dispatch('OPEN_LOADING')
                res = await calendar.delete.customer(payload)
                console.log("DELETE_A_SCHEDULE info", res)
                if (res.data.status === 201) {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success'
                    })
                } else {
                    store.dispatch('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error'
                    })
                }
                store.dispatch('CLOSE_LOADING')
                return res.data
            } catch(error) {
                console.error("DELETE_A_SCHEDULE error", error)
                store.dispatch('CLOSE_LOADING')
            }
        }
    },
    getters: {
        SCHEDULES_LIST: state => {
            return {
                events: state.schedules,
                recipients: state.recipientList,
                staffs: state.staffList
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/calendars.js